var _circle, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChina(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#ED181E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76707 6.87695L10.7137 9.79034L13.777 9.79034L11.2987 11.5909L12.2453 14.5043L9.76707 12.7037L7.2888 14.5043L8.23542 11.5909L5.75714 9.79034L8.82046 9.79034L9.76707 6.87695Z",
    fill: "#FFDF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7371 5.51615L17.6119 6.55559L18.5618 6.99588L17.5345 7.198L17.4093 8.23745L16.8996 7.32293L15.8724 7.52506L16.5846 6.75772L16.0749 5.8432L17.0248 6.28349L17.7371 5.51615Z",
    fill: "#FFDF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2077 8.754L20.7125 9.67641L21.4367 10.4325L20.4064 10.2465L19.9112 11.1689L19.7696 10.1316L18.7393 9.94558L19.6822 9.49044L19.5407 8.45309L20.2649 9.20914L21.2077 8.754Z",
    fill: "#FFDF00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.101 12.9173L20.4094 13.9178L21.4563 13.9336L20.6 14.5361L20.9085 15.5366L20.0709 14.9085L19.2147 15.511L19.5532 14.5203L18.7156 13.8922L19.7624 13.908L20.101 12.9173Z",
    fill: "#FFDF00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6893 15.8614L17.6195 16.906L18.5914 17.2952L17.5763 17.5516L17.5065 18.5962L16.949 17.7101L15.9339 17.9665L16.6044 17.1624L16.0469 16.2763L17.0188 16.6655L17.6893 15.8614Z",
    fill: "#FFDF00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChina);
export default __webpack_public_path__ + "static/media/china.6b9c87e7bdbc8e3398caf3fca508b845.svg";
export { ForwardRef as ReactComponent };